import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { usePlanLimitModalStore } from '@/stores/plan-limit-modal-store';

export function PlanLimitModal() {
  const open = usePlanLimitModalStore((state) => state.open);
  const config = usePlanLimitModalStore((state) => state.config);
  const hidePlanLimitModal = usePlanLimitModalStore((state) => state.hidePlanLimitModal);

  if (!config) return null;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(nextOpen) => !nextOpen && hidePlanLimitModal()}
      title={config.title}
      description={config.description}
      confirmLabel={config.confirmLabel}
      cancelLabel={config.cancelLabel}
      confirmVariant="solid"
      size="md"
      contentClassName="z-[160]"
      onConfirm={() => {
        config.onConfirm();
        hidePlanLimitModal();
      }}
    />
  );
}
